"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StringManipulater_1 = require("Utils/StringManipulater");
exports.default = (function (modal, seatsService) {
    return function (numberOfInvites, isTrial, onConfirming) { return __awaiter(void 0, void 0, Promise, function () {
        var usersNoun, currentlyPaidForSeats, numberOfNewSeatsRequired, explainer, confirmLabel, timeUnitString, seatPrice, totalCharge, alreadyPaidSeats, requiredSeatsNoun, alreadyPaidUsersPhrase, ctaClicked;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    usersNoun = (0, StringManipulater_1.pluraliseWord)(numberOfInvites, "user", "users");
                    currentlyPaidForSeats = Math.max(seatsService.minSeats(), seatsService.seatsOnAccount());
                    numberOfNewSeatsRequired = seatsService.currentlyOccupied() + numberOfInvites - currentlyPaidForSeats;
                    confirmLabel = "Invite and pay";
                    if (isTrial) {
                        explainer = (react_1.default.createElement(react_1.default.Fragment, null, "Your trial allows you to invite users for free. If you choose to upgrade, you\u2019ll be charged for these users, but you easily manage and remove users at any time."));
                        confirmLabel = "Invite";
                    }
                    else {
                        if (numberOfNewSeatsRequired <= 0) {
                            explainer = (react_1.default.createElement(react_1.default.Fragment, null, "Your plan comes with included users, so no extra charges will apply for inviting this user to your account."));
                            confirmLabel = "Invite";
                        }
                        else {
                            timeUnitString = seatsService.timeUnit() === "month" ? "monthly" : "yearly";
                            seatPrice = seatsService.seatPrice();
                            totalCharge = numberOfNewSeatsRequired * seatPrice;
                            if (numberOfNewSeatsRequired < numberOfInvites) {
                                alreadyPaidSeats = numberOfInvites - numberOfNewSeatsRequired;
                                requiredSeatsNoun = (0, StringManipulater_1.pluraliseWord)(numberOfNewSeatsRequired, "user", "users");
                                alreadyPaidUsersPhrase = (0, StringManipulater_1.pluralise)(alreadyPaidSeats, "user", "users");
                                explainer = (react_1.default.createElement(react_1.default.Fragment, null, "Your plan includes  ".concat(alreadyPaidUsersPhrase, " and you will be "),
                                    react_1.default.createElement("b", null, "charged $".concat(totalCharge, " ").concat(timeUnitString, " ")), "for the ".concat(numberOfNewSeatsRequired, " extra ").concat(requiredSeatsNoun, " joining your account.")));
                            }
                            else {
                                explainer = (react_1.default.createElement(react_1.default.Fragment, null,
                                    "You'll be charged",
                                    react_1.default.createElement("b", null, " $".concat(totalCharge, " ").concat(timeUnitString, " ")), "for the new ".concat(usersNoun, " joining your account. We'll send you an email with these changes.")));
                            }
                        }
                    }
                    return [4, modal.showConfirmModal({
                            title: "Invite ".concat(numberOfInvites, " ").concat(usersNoun, " to your account?"),
                            explainer: explainer,
                            confirmLabel: confirmLabel,
                            confirming: onConfirming,
                        })];
                case 1:
                    ctaClicked = _a.sent();
                    return [2, ctaClicked];
            }
        });
    }); };
});
